import * as Sentry from '@sentry/react';

import { setWindowLocation } from 'utils/setWindowLocation';

import { getMailroomUrl } from './getMailroomUrl';

export const redirectToMailroom = (region: OP.Env, orgId?: number | null) => {
  // Should never happen but just in case
  if (!orgId) {
    Sentry.captureMessage('No orgId provided to redirectToUpc', {
      contexts: {
        debugInfo: {
          location: JSON.stringify(window.location),
          region,
        },
      },
    });
  }
  setWindowLocation(`${getMailroomUrl(region)}/o/${orgId}`);
};
